import React from 'react';
import { Alert, Box, Button, Stack } from '@mui/material';

const ADMINISTRATION_STATUS_LABELS = {
  taken: 'Given',
  missed: 'Missed',
  late: 'Given late',
  refused: 'Refused',
  partial: 'Partly given',
  extra: 'Extra dose given',
  vomited: 'Vomited',
  uncertain: 'Needs clarification',
};

const getStatusLabel = (administration = {}) => (
  ADMINISTRATION_STATUS_LABELS[administration.status] || 'Needs clarification'
);

const MedicationAdministrationReviewActions = ({ controller, onOpenMedicationProfile = null }) => {
  if (!controller?.status) return null;

  if (controller.status === 'dismissed') return null;

  if (controller.status === 'confirmed') {
    return controller.confirmedAdministrations?.length ? (
      <Stack spacing={0.25} sx={{ mt: 0.8 }}>
        {controller.confirmedAdministrations.map((administration, index) => (
          <Button
            key={`${administration.medicationId || administration.medicationName || 'medication'}-${index}`}
            variant="text"
            onClick={controller.openReview}
            disabled={controller.loading}
            sx={{ justifyContent: 'flex-start', px: 0, textTransform: 'none', fontWeight: 800 }}
          >
            Status — {administration.medicationName || 'Medication'} — {getStatusLabel(administration)}
          </Button>
        ))}
        {onOpenMedicationProfile ? (
          <Button
            variant="text"
            onClick={onOpenMedicationProfile}
            sx={{ justifyContent: 'flex-start', px: 0, textTransform: 'none', fontWeight: 800 }}
          >
            Open medication profile
          </Button>
        ) : null}
      </Stack>
    ) : null;
  }

  return (
    <Box sx={{ mt: 0.5 }}>
      {controller.error && !controller.open && !controller.addOpen ? (
        <Alert severity="error" sx={{ mt: 0.7 }}>{controller.error}</Alert>
      ) : null}
      {controller.isPending ? (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={0.7}>
          <Button variant="text" size="small" onClick={controller.openReview} disabled={controller.loading} sx={{ alignSelf: 'flex-start', px: 0 }}>
            {controller.loading ? 'Opening…' : 'Review medication'}
          </Button>
          {onOpenMedicationProfile ? (
            <Button variant="text" size="small" onClick={onOpenMedicationProfile} sx={{ alignSelf: 'flex-start', px: 0 }}>
              Open medication profile
            </Button>
          ) : null}
        </Stack>
      ) : null}
    </Box>
  );
};

export default MedicationAdministrationReviewActions;
